module.exports = __webpack_public_path__ + "img/img-18.6a2778b5.png";